import { URLS } from '@/data/config';
import { createActiveWalletJurisdictionHeaders } from '@/hooks/use-active-wallet';
import { z } from 'zod';

export enum TrustlyStatusValue {
    SUCCESS = 'success',
    PENDING = 'pending',
    FAIL = 'fail',
    FRAUD_ANALYSIS = 'fraud_analysis',
    INVALID_ACCOUNT = 'invalid_account',
    INSUFFICIENT_FUNDS = 'insufficient_funds',
}

const TrustlyStatusEnum = z.enum([
    TrustlyStatusValue.SUCCESS,
    TrustlyStatusValue.PENDING,
    TrustlyStatusValue.FAIL,
    TrustlyStatusValue.FRAUD_ANALYSIS,
    TrustlyStatusValue.INVALID_ACCOUNT,
    TrustlyStatusValue.INSUFFICIENT_FUNDS,
]);

const TrustlyStatusSchema = z.object({
    status: z.union([TrustlyStatusEnum, z.string()]),
});

export type TrustlyStatus = z.infer<typeof TrustlyStatusEnum> | string;

const TrustlyStatusResponseSchema = z.object({
    data: TrustlyStatusSchema,
});

type FetchTrustlyStatusParams = {
    userWalletId: string;
};

/**
 * Fetches the current status of a Trustly transaction
 * @param params Object containing userWalletId
 * @returns Parsed response with Trustly status
 */
export const fetchTrustlyStatus = async ({ userWalletId }: FetchTrustlyStatusParams) => {
    const response = await fetch(`${URLS.CHAMELON_API_URL}/auth/wallet/trustly/status?user_wallet_id=${userWalletId}`, {
        method: 'GET',
        headers: {
            ...createActiveWalletJurisdictionHeaders(),
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    return TrustlyStatusResponseSchema.parse(data);
};
